var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultilingualLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.551,
    height: 37,
    viewBox: "0 0 43.551 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1828",
    "data-name": "Rectangle 1828",
    width: 43.551,
    height: 37,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9030",
    "data-name": "Group 9030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9029",
    "data-name": "Group 9029",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11576",
    "data-name": "Path 11576",
    d: "M32.414,29.564h-8.5a1.565,1.565,0,0,1,0-3.13h8.5a7.05,7.05,0,0,0,7.042-7.042V9.925a2.307,2.307,0,0,0-2.3-2.3,1.565,1.565,0,0,1,0-3.13,5.44,5.44,0,0,1,5.433,5.433v9.467A10.183,10.183,0,0,1,32.414,29.564",
    transform: "translate(0.966 0.194)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11577",
    "data-name": "Path 11577",
    d: "M10.3,36.819a1.565,1.565,0,0,1-1.564-1.535l-.117-6.041A9.3,9.3,0,0,1,0,19.977V9.628A5.44,5.44,0,0,1,5.433,4.2a1.565,1.565,0,1,1,0,3.13,2.307,2.307,0,0,0-2.3,2.3V19.977a6.167,6.167,0,0,0,6.16,6.16h2.4l.175,9.086a1.565,1.565,0,0,1-1.535,1.6H10.3",
    transform: "translate(0 0.181)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11578",
    "data-name": "Path 11578",
    d: "M12.987,34.538,12.8,25.072H9.619a5.44,5.44,0,0,1-5.433-5.433V5.433A5.439,5.439,0,0,1,9.619,0H32.888a5.44,5.44,0,0,1,5.433,5.433V19.639a5.44,5.44,0,0,1-5.433,5.433h-9.5ZM9.619,3.13a2.307,2.307,0,0,0-2.3,2.3V19.639a2.307,2.307,0,0,0,2.3,2.3h6.255l.108,5.638,6.194-5.638H32.888a2.307,2.307,0,0,0,2.3-2.3V5.433a2.307,2.307,0,0,0-2.3-2.3Z",
    transform: "translate(0.181 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11579",
    "data-name": "Path 11579",
    d: "M15.811,11.987a1.817,1.817,0,1,1-1.817-1.817,1.817,1.817,0,0,1,1.817,1.817",
    transform: "translate(0.526 0.439)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11580",
    "data-name": "Path 11580",
    d: "M22.416,11.987A1.817,1.817,0,1,1,20.6,10.17a1.817,1.817,0,0,1,1.817,1.817",
    transform: "translate(0.812 0.439)",
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11581",
    "data-name": "Path 11581",
    d: "M29.021,11.987A1.817,1.817,0,1,1,27.2,10.17a1.817,1.817,0,0,1,1.817,1.817",
    transform: "translate(1.097 0.439)",
    fill: "#a4c639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultilingualLogo);
export default __webpack_public_path__ + "static/media/multilingualLogo.7fd963a48bbdc9b13c0ffdcf56b2fce2.svg";
export { ForwardRef as ReactComponent };